import { render, staticRenderFns } from "./AudienceHistory.vue?vue&type=template&id=c6c1fd12&"
import script from "./AudienceHistory.vue?vue&type=script&lang=ts&"
export * from "./AudienceHistory.vue?vue&type=script&lang=ts&"
import style0 from "./AudienceHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports